import { useTranslation } from 'react-i18next'
import React from 'react'

import { Title } from '../../../../components/presentation/Text'
import Avatar from '../../../../components/presentation/Avatar'
import DateTimeIcons from '../../../../components/presentation/DateTimeIcons'
import Map from '../../../../components/map/Map'
import Panel from '../../../../components/structure/Panel'
import Separator from '../../../../components/helpers/Separator'
import { incrementCheckout, shouldIncrementCheckout } from '../../../../utils/helpers/serviceOrder'
import { useSessionPermission } from '@btime/react-session'

const getCheckEvent = (events = [], eventDate, statusId) =>
  events.find(
    item =>
      item.eventDate === eventDate && //
      item.status?.id === statusId
  )

const CheckInOutDetailsPanel = ({ serviceOrder, type }) => {
  const hideCheckinAndCheckout = useSessionPermission('hideCheckinAndCheckout')
  const { t } = useTranslation('serviceOrders')
  const shouldIncrement = type === 'checkOut' && shouldIncrementCheckout(serviceOrder)
  const eventDate = type === 'checkIn' ? serviceOrder.startDate : serviceOrder.endDate
  const statusId = type === 'checkIn' ? 5 : 8
  let check = getCheckEvent(serviceOrder.events, eventDate, statusId)
  // TODO: Remove after all is moved to new api
  if (!check) check = serviceOrder[type]
  if (!check) return false
  if (hideCheckinAndCheckout) return false

  const userName = serviceOrder.user?.name
  const address = check.address || {}
  const center = { lat: address.latitude, lng: address.longitude }

  return (
    <Panel lineBorder mediumPadding flex={1} noMargin>
      <Title size="h6">{t('fields.' + type)}</Title>
      <Separator />
      <DateTimeIcons gutter={2} date={shouldIncrement ? incrementCheckout(check.eventDate) : check.eventDate} />

      <Separator weight={3} />

      <Map center={center}>
        <Avatar name={userName} lat={address.latitude} lng={address.longitude} text={userName} />
      </Map>
    </Panel>
  )
}

export default CheckInOutDetailsPanel
